(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 10) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 40);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero-banner__video').forEach((video) => {
    if (video.dataset.posterBound === 'true') return;
    video.dataset.posterBound = 'true';

    const wrapper = video.closest('.hero-banner__video-wrapper');
    const hasPoster = Boolean(wrapper && wrapper.querySelector('.hero-banner__video-poster'));

    const hidePoster = () => {
      if (wrapper) wrapper.classList.add('is-playing');
    };

    const revealIfPlaying = () => {
      if (video.paused || video.currentTime <= 0) return;
      hidePoster();
      video.removeEventListener('timeupdate', revealIfPlaying);
    };

    const tryPlay = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const pending = video.play();
      if (pending && typeof pending.catch === 'function') pending.catch(function () {});
    };

    // iOS often ignores <source media> and then never starts autoplay, so the
    // poster stays up. Assign the matching file directly.
    const sources = Array.from(video.querySelectorAll('source[src]')).map((source) => ({
      src: source.src,
      media: source.media
    }));
    const match = sources.find((source) => !source.media || window.matchMedia(source.media).matches) || sources[sources.length - 1];

    const replacedSource = Boolean(match && video.currentSrc !== match.src);
    if (replacedSource) {
      video.querySelectorAll('source').forEach((source) => source.remove());
      video.src = match.src;
    }

    if (hasPoster) {
      if (!video.paused && video.currentTime > 0) {
        hidePoster();
      } else {
        video.addEventListener('playing', hidePoster);
        video.addEventListener('timeupdate', revealIfPlaying);
      }
    }

    if (replacedSource || video.readyState < 2) {
      video.addEventListener('canplay', tryPlay, { once: true });
    }
    tryPlay();

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && video.paused) tryPlay();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
